import styled from '@emotion/styled';
import { colors, Stack } from '@ui-components/neo.tax';

export const HeroContainer = styled(Stack)({
  backgroundColor: colors.blue[700],
  borderRadius: '6px',
  minHeight: 284,
  position: 'relative',
});
